import React from 'react';

import { ScrapbookStore } from "vbook-ui-components/src/scrapbook/store/ScrapbookStore";
import { ScrapbookProvider } from "vbook-ui-components/src/scrapbook/providers/ScrapbookProvider";
import { ScrapbookProviderWeb } from "vbook-ui-components/src/scrapbook/providers/ScrapbookProviderWeb";
import { SourceApp } from "vbook-ui-components/src/Config";
import { GlobalStateInfo } from "../utils/GlobalStateInfo";
import { TextAddonsProvider } from "../services/textAddonsService/TextAddonsProvider";
import ScreenScrollManager from "./ScreenScrollManager";
import Highlighter from "../components/misc/Highlighter";
import { TextMarginaliaManager } from "../features/bookEnchancements/textMarginalia/TextMarginaliaManager";
import { ManningOnlineTour, IManningOnlineTourState } from "../pages/manning-online/ManningOnlineTour";
import EventUtils from "../utils/EventUtils";
import { DynamicCodeLoader } from "../utils/DynamicCodeLoader";
import { ManningOnlineScrapbookTourModal } from "vbook-ui-components/src/subscriptions/components/manningOnlineTour/ManningOnlineScrapbookTourModal";
import { ReactUtils } from '../utils/ReactUtils';

class ScrapbookManagerClass {
    private store: ScrapbookStore;
    private tourState: IManningOnlineTourState;

    constructor(){
        console.log("Scrapbook manager init");
        // debugger;
    }
    
    public getStore(): ScrapbookStore {
        if(this.store != null) { return this.store; }
        this.store = new ScrapbookStore(
            new ScrapbookProvider(
                new ScrapbookProviderWeb(
                    SourceApp.livebook, 
                    GlobalStateInfo.getDeploymentType()
                )
            )
        );

        ManningOnlineTour.getTourState().then(tourState => {
            this.tourState = tourState;
        });

        this.store.onBeforeToggle = () => {
            const result = this.tourState == null || this.tourState.hasSeenScrapbookTour;

            if(!result){
                EventUtils.setTimeout(() => {
                    this.renderScrapbookTour(this.tourState);
                }, 150);
            }
            
            return result;
        };

        this.store.onTourRequested = () => {
            EventUtils.setTimeout(() => {
                this.renderScrapbookTour(this.tourState);
            }, 150);
        };

        return this.store;
    }

    private renderScrapbookTour(tourState: IManningOnlineTourState){
        DynamicCodeLoader.loadShepherd().then(() => {
            const root = ReactUtils.createRoot(document.getElementById("full-screen-modal"));
            root.render(
                React.createElement(ManningOnlineScrapbookTourModal, {
                    onClose: () => {
                        tourState.hasSeenScrapbookTour = true;
                        ManningOnlineTour.storeTourState(tourState);
                        ReactUtils.unmountAtNode(document.getElementById("full-screen-modal"));
                        if(!this.store.state.isShown){
                            this.store.toggleShown();
                        }
                    }
                })
            );
        });
    }

    public scrollToScrapbookItem(info: string){
        const [userId, hash] = atob(info).split("-");
        const $targetElement = $(`[data-hash='${hash}']`);
        ScreenScrollManager.scrollToElement($targetElement[0]);

        $targetElement.addClass("paragraph-focused");
        $(document).trigger("requestNotification", "Fetching content ...");
        TextAddonsProvider.getScrapbookItemFromTextAddon(
            userId, 
            GlobalStateInfo.book.shortName, 
            GlobalStateInfo.bookElement.shortName,
            GlobalStateInfo.bookElement.meapVersion,
            hash
        ).then((data) => {
            $(document).trigger("hideNotification");
            if(data && data.highlights){
                data.highlights.forEach(highlight => {
                    Highlighter.highlight($targetElement[0], highlight.text, `highlighted-text highlight-color-${highlight.color}`);
                });
            }

            if(data && data.notes){
                data.notes.forEach(note => {
                    TextMarginaliaManager.appendNote($targetElement, `${data.user}: ${note.text}`, note.id);
                })
            }

        }).catch(e => {
            $(document).trigger("requestNotification", "Error fetching scrapbook shared item");
        });
    }
}

export const ScrapbookManager = new ScrapbookManagerClass();